export default "__VITE_PUBLIC_ASSET__31625f75__"